import React, { useEffect, useState } from "react";

//JWT Decoder
import jwtDecode from "jwt-decode";

//Components
import ModalWindow from "./Modal";

//Constants
import { hostPath } from "../Constants/constants";

export default function ProtectedRoute({ children }) {
  // Extracted and verification of token from local storage
  const [token, setToken] = useState(localStorage.token?.replace(/"/g, ""));
  //

  //Function to get token
  const getToken = async () => {
    const userEmail = JSON.parse(localStorage.getItem("userEmail"));
    const password = JSON.parse(localStorage.getItem("password"));

    try {
      const requestResponse = await fetch(hostPath + `/users/sign-in`, {
        method: "POST",
        body: JSON.stringify({ userEmail, password }),
        headers: {
          "Content-type": "application/json",
        },
      });
      const jsonResponse = await requestResponse.json();

      const newToken = jsonResponse.token;

      localStorage.setItem("token", JSON.stringify(newToken));
      setToken(newToken);

      localStorage.setItem("userData", JSON.stringify(jsonResponse.userData));
    } catch (error) {
      console.log(error);
    }
  };

  // The useEffect checks for token validation
  useEffect(() => {
    // Configurar el intervalo para ejecutar reauthenticate cada 5 minutos
    const interval = setInterval(() => {
      getToken();
    }, 600000);

    // Limpiar el intervalo cuando el componente se desmonte o cuando las dependencias cambien
    return () => {
      clearInterval(interval);
    };
  }, [token]);

  // Function for verifying token
  const isValidToken = () => {
    // Initialize variable holding decoded JWT token
    let decoded = null;

    // Token decodification
    try {
      decoded = jwtDecode(token);
    } catch (e) {
      decoded = null;
    }

    if (decoded) {
      return new Date().getTime() < decoded.exp * 1000;
    } else {
      return false;
    }
  };

  if (isValidToken()) {
    return children;
  } else {
    return (
      <ModalWindow
        isOpen={true}
        title="Su sesión expiró"
        text="Por favor vuelva a iniciar sesión"
        leftText="Volver a iniciar sesión"
        leftClick={() => {
          localStorage.removeItem("token");
          localStorage.removeItem("userData");
          localStorage.removeItem("userEmail");
          localStorage.removeItem("password");
          window.location.href = "/";
        }}
      />
    );
  }
}
